import browserPaths from "@/details/navigation/browser/browserPaths";
import {
  canFeature,
  type PermissionCanFn,
} from "@/app/shared/permissions/permissionKernel";
import type { FeaturePermissionKey } from "@/app/shared/permissions/featurePermissions";

const ensureAbsolute = (rel: string): string =>
  rel.startsWith("/") ? rel : `/${rel}`;

/**
 * Persona → dedicated dashboard path, in strict 1:1 priority order (P1→P4).
 * Each persona only owns its own dashboard (Keycloak `DASHBOARD_READ:Px`).
 */
const PERSONA_DASHBOARDS: ReadonlyArray<{
  readonly feature: FeaturePermissionKey;
  readonly path: string;
}> = [
  { feature: "DASHBOARD_P1_READ", path: browserPaths.DASHBOARD.COMMERCIAL_DASHBOARD },
  { feature: "DASHBOARD_P2_READ", path: browserPaths.DASHBOARD.AGENCE_DASHBOARD },
  { feature: "DASHBOARD_P3_READ", path: browserPaths.DASHBOARD.COMPLIANCE_DASHBOARD },
  { feature: "DASHBOARD_P4_READ", path: browserPaths.DASHBOARD.CONFORMITE_DASHBOARD },
];

/**
 * Default dashboard path from effective permissions (tuple-based).
 * Returns the persona-owned dashboard, or null when none applies — caller
 * shows the generic dashboard.
 */
export const getDefaultDashboardPath = (
  can?: PermissionCanFn,
): string | null => {
  const match = PERSONA_DASHBOARDS.find((entry) =>
    can ? canFeature(entry.feature, can) : canFeature(entry.feature),
  );
  return match ? ensureAbsolute(match.path) : null;
};
